export enum FieldProps {
  SIZE_BIG = 'big',
  SIZE_SMALL = 'small',

  INGREDIENT_NAME = 'ingredientName',
  INGREDIENT_NAME_PLACEHOLDER = 'Enter Ingredient Name',

  SUPPLIER_NAME = 'supplier',
  SUPPLIER_PLACEHOLDER = 'Supplier',

  TEMPERATURE_CONTROL = 'temperaturControl',
  TEMPERATUR_CONTROL_PLACEHOLDER = 'Temperature control',

  VIA_AIR = 'viaAir',
  VIA_AIR_PLACEHOLDER = 'Check this box if transportation is via air',
  VIA_AIR_LABEL = 'Check this box if transportation is via air',

  PACKAGING_SUPPLIER = 'packingSupplier',
  PACKAGING_TEMPERATURE_CONTROL = 'packingTemperatureControl',
  PACKAGING_VIA_AIR = 'packingViaAir',

  INGREDIENT_ORIGIN = 'ingredientOrigin',
  INGREDIENT_ORIGIN_PLACEHOLDER = 'Enter Ingredient Origin',

  INGREDIENT_REGION = 'bestFitProductionRegion',
  INGREDIENT_REGION_PLACEHOLDER = 'Select Best Fit Production Region',

  INGREDIENT_QUANTITY = 'ingredientQuantity',
  INGREDIENT_QUANTITY_PLACEHOLDER = 'Quantity',

  INGREDIENT_UNIT = 'ingredientUnit',
  INGREDIENT_UNIT_PLACEHOLDER = 'Unit',

  PACKAGING_NAME = 'packingMaterialName',
  PACKAGING_NAME_PLACEHOLDER = 'Enter Packaging Material name/origin',

  PACKAGING_ORIGIN = 'packingMaterialOrigin',
  PACKAGING_ORIGIN_PLACEHOLDER = 'Enter Packaging Material Origin',

  PACKAGING_REGION = 'packingMaterialbestFitProductionRegion',
  PACKAGING_REGION_PLACEHOLDER = 'Select Best Fit Production Region',

  PACKAGING_QUANTITY = 'packingMaterialQuantity',
  PACKAGING_QUANTITY_PLACEHOLDER = 'Quantity',

  PACKAGING_UNIT = 'packingMaterialUnit',
  PACKAGING_UNIT_PLACEHOLDER = 'Unit',

  PACKAGING_UNITS_PER_PACKAGING = 'numberOfUnitsPerPackingMaterial',
  PACKAGING_UNITS_PER_PACKAGING_PLACEHOLDER = 'Number of units per packaging material',
}

export enum FacilityProps {
  INGREDIENT = 'ingredient',
  INGREDIENTS = 'ingredients',
  PACKAGING = 'packaging',
  HEADING = 'New Product',
  LOADING_INDICATOR = 'Loading...',
  FACILITY_HEADING = '3. Processing Facility',
  PACKAGE_MATERIAL = 'packageMaterials',
  PACKAGE_MATERIAL_HEADING = 'Packaging Material',
  NEW_PRODUCT = 'New Product',
  OTHER = 'scope3_category1',
  FERTILISERS = 'fertilizer',
  FEED = 'feed',
}
export enum DUMMY_DATA {
  name = 'Facility A',
  address = '123 Main St.',
  scope1 = 'State',
  scope2 = 'Country',
}

export enum ButtonLabels {
  CANCEL = 'Cancel',
  SAVE_AS_DRAFT = 'Save as Draft',
  ADD_INGREDIENT = 'Add ingredient',
  ADD_PACKAGING_MATERIAL = 'Add packaging material',
  PER_250_GMS = '/250G',
  NEXT = 'Next',
}
